import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
// Entities
import { Blocking, Company } from "@/entities/index";

@Component
export default class OneBlockage extends Vue {
  client = this.company.codeLogistic;
  @Prop() readonly reference!: string;
  @Prop() readonly warehouse!: string;
  @Prop() readonly lot!: string;
  @Prop() readonly cause!: string;
  integrateStepZero = this.company.integrateStepZero;

  @Watch("reference")
  onReferenceChange(value: string, oldValue: string) {
    this.loadOneBlockage();
  }

  blocking: Blocking[] = [];
  blockingCSV: Blocking[] = [];

  headers = [
    {
      text: this.$t("Blocking.table.reference"),
      class: "indigo--text text--darken-4",
      align: "start",
      value: "reference",
    },
    {
      text: this.$t("Blocking.table.designation"),
      class: "indigo--text text--darken-4",
      value: "designation",
    },
    {
      text: this.$t("Blocking.table.lot"),
      class: "indigo--text text--darken-4",
      value: "lot",
    },
    {
      text: this.$t("Blocking.table.blockingQuantity"),
      class: "indigo--text text--darken-4",
      value: "blockingQuantity",
    },
    {
      text: this.$t("Blocking.table.blockingDate"),
      class: "indigo--text text--darken-4",
      value: "blockingDate",
    },
    {
      text: this.$t("Blocking.table.daysOfBlocking"),
      class: "indigo--text text--darken-4",
      value: "dayOfBlocking",
    },
    {
      text: this.$t("Blocking.table.warehouse"),
      class: "indigo--text text--darken-4",
      value: "warehouse",
    },
    {
      text: this.$t("Blocking.table.cause"),
      class: "indigo--text text--darken-4",
      value: "cause",
    },
  ];

  headersCSV = [
    {
      text: "Reference",
      value: "reference",
    },
    { text: "Designation", value: "designation" },
    { text: "Lot", value: "lot" },
    { text: "Quantite blocage", value: "blockingQuantity" },
    { text: "Date de blocage", value: "blockingDate" },
    { text: "Jours de blocage", value: "dayOfBlocking" },
    { text: "Entrepot", value: "warehouse" },
    { text: "Motif de blocage", value: "cause" },
  ];

  async loadOneBlockage(): Promise<void> {
    this.blocking = (
      await axios.post(`/api/blockages/one`, {
        client: this.client,
        reference: this.reference,
        lot: this.lot,
        warehouse: this.warehouse,
        integrateStepZero: this.integrateStepZero,
      })
    ).data as Blocking[];
    const userId = this.profile.id;
    await axios.post("/api/stats/action", {
      userId,
      action: "Consultation d'un seul blocage",
    });
  }

  async mounted(): Promise<void> {
    this.loadOneBlockage();
  }

  // ========== GETTERS ========== //

  get company(): Company {
    return this.$store.getters.company;
  }

  get profile() {
    return this.$store.getters.profile;
  }

  // ========== OTHERS METHODS ========== //

  colorRow(item: Blocking): any {
    const position = this.blocking.indexOf(item, 0);
    if (position % 2 == 0) {
      return "light-green lighten-5";
    }
  }

  // === EXPORT TO CSV === //

  async getBlockageCSV(): Promise<Blocking[]> {
    const response = await axios.post(`/api/blockages/one`, {
      client: this.client,
      reference: this.reference,
      lot: this.lot,
      warehouse: this.warehouse,
      cause: this.cause,
    });
    const blockingCSV = response.data as Blocking[];
    const userId = this.profile.id;
    await axios.post("/api/stats/action", {
      userId,
      action: "Extraction d'un seul blocage en CSV",
    });
    return blockingCSV;
  }

  convertToCSV(json: any): string {
    if (json.reference === undefined || json.reference === null) {
      json.reference = "";
    }
    if (json.designation === undefined || json.designation === null) {
      json.designation = "";
    }
    if (json.lot === undefined || json.lot === null) {
      json.lot = "";
    }
    if (json.blockingQuantity === undefined || json.blockingQuantity === null) {
      json.blockingQuantity = "";
    }
    if (json.blockingDate === undefined || json.blockingDate === null) {
      json.blockingDate = "";
    }
    if (json.dayOfBlocking === undefined || json.dayOfBlocking === null) {
      json.dayOfBlocking = "";
    }
    if (json.warehouse === undefined || json.warehouse === null) {
      json.warehouse = "";
    }
    if (json.cause === undefined || json.cause === null) {
      json.cause = "";
    }
    json.designation = json.designation.replace(/ /g, "");
    return `"${json.reference}";"${json.designation}";"${json.lot}";"${json.blockingQuantity}";"${json.blockingDate}";"${json.dayOfBlocking}";"${json.warehouse}";"${json.cause}"`;
  }

  async downloadCSV(): Promise<void> {
    const blockingCSV = await this.getBlockageCSV();
    const csvJSON = this.blockingCSV.map((json: any) =>
      this.convertToCSV(json)
    );
    csvJSON.unshift(
      this.headersCSV.map((header: any) => header.text).join(";")
    );
    const csvData = csvJSON.join("\n");
    const csvBlob = new Blob([csvData], { type: "text/csv;charset=utf-8" });
    const csvUrl = URL.createObjectURL(csvBlob);
    const link = document.createElement("a");
    link.href = csvUrl;
    link.download = "Blocage.csv";
    link.click();
  }
}
